import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import settingReducer from "./slices/setting";
import dealerReducer from "./slices/dealer";
import productReducer from "./slices/product";
import inventoryReducer from "./slices/inventory";
import challanReducer from "./slices/challan";
import oemReducer from "./slices/oem"

const reducer = {
  auth: authReducer,
  message: messageReducer,
  setting: settingReducer,
  dealer: dealerReducer,
  product: productReducer,
  inventory: inventoryReducer,
  challan: challanReducer,
  oem: oemReducer
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
})

export default store;